import React, { useState, useEffect } from 'react';
import useAxiosPrivate from "../hooks/useAxiosPrivate"
import ExportSVG from '../icon/ExportSVG'
import { downloadExcel } from "react-export-table-to-excel";
import Loading from "../Loading"


export const getClassName = (index, data) => {
    if (index % 2 === 0) {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader OddDiv Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader OddDiv Red"
        } else {
            return "PeerTabledataCenter SubHeader OddDiv Black"
        }
    } else {
        if (data > 0) {
            return "PeerTabledataCenter SubHeader Green"
        } else if (data < 0) {
            return "PeerTabledataCenter SubHeader Red"
        } else {
            return "PeerTabledataCenter SubHeader Black"
        }
    }
}


function InvestmentActivityMobile(props) {
    const [pageData, setpageData] = useState({});
    const axiosPrivate = useAxiosPrivate();
    const companyDetails = async () => {
        setpageData({})
        let url = ""
        url = process.env.REACT_APP_BASE_URL + "/v1/historical-holdings/" + props.investor + "?access_token=" + process.env.REACT_APP_DATA_API_SECRET_KEY;

        const cdresponse = await axiosPrivate.get(url);
        if (cdresponse.data.status === "Not Found") {
            setpageData({ dataNotFound: true })
            return
        }
        let tempData = cdresponse.data
        tempData.activities?.reverse()
        setpageData(tempData)
    }

    function handleDownloadExcel() {

        let header = ["S. No.", "Stock Symbol", "Name", "% of Portfolio", "Activity", "Change", "Change%", "Shares", "Current Price", "Investment Value (Cr)", "52W Low", "52W High", "% Above 52W low", "Industry", "Sector"]
        let body = []

        pageData?.investments.forEach((item, index) => {
            let tempData = [index + 1]
            tempData.push(item.stock_symbol)
            tempData.push(item.name)
            tempData.push(item.pctOfProfile)
            tempData.push(item.activity)
            tempData.push(item.change)
            tempData.push(item.pctChange)
            tempData.push(item.share)
            tempData.push(item.currentPrice)
            tempData.push(item.investmentValue)
            tempData.push(item.low52)
            tempData.push(item.high52)
            tempData.push(item.pctAbove52WLow)
            tempData.push(item.industry)
            tempData.push(item.sector)
            body.push(tempData)
        })


        downloadExcel({
            fileName: "Investor",
            sheet: "Investor",
            tablePayload: {
                header,
                // accept two different data structures
                body: body,
            },
        });
    }

    


    const getUrl = (url) => {
        return "/CompanyInvestor/" + url
    }

    useEffect(() => {
        companyDetails()
    }, [props.investor])

    return (
        <div style={{ overflowY: "auto" }}>
            {Object.keys(pageData).length !== 0 &&
                <>
                <section className="optionsFinDataMobile" style={{ width: "100%"}}>
                        <div className="leftAlign growthCompanyName" style={{ paddingLeft: "0px", fontWeight: "600" }}>
                            {pageData.shareholder_name}
                        </div>
                        <div className="rightAlign">
                            <div className="optionButtonPrimary" onClick={handleDownloadExcel} style={{ cursor: "pointer" }}>
                            {// <ExportSVG />
                            }
                            </div>
                        </div>
                    </section>
                <div className="CompanyNavMobile" style={{ fontSize:"9px" }}>

                    <div className="CompanyMenuMobile" id="current" onClick={() => {
                        props.setNav('current')
                    }
                    } style={props.nav === "current" ? { backgroundColor: '#000', color: '#fff' } : { color: '#3e424b' }}>Current</div>
                    <div className="CompanyMenuMobile" id="Activity" onClick={() => {
                        props.setNav('Activity')
                    }
                    } style={props.nav === "Activity" ? { backgroundColor: '#000', color: '#fff' } : { color: '#3e424b' }}>Activity</div>
                    <div className="CompanyMenuMobile" id="History" onClick={() => {
                        props.setNav('History')
                    }
                    } style={props.nav === "History" ? { backgroundColor: '#000', color: '#fff' } : { color: '#3e424b' }}>History</div>

                </div>
                <div style={{ backgroundColor: "white", borderRadius: "10px", width: "100%", padding: "10px 0px", overflowX: "auto"}}>
                    <table className="PeersTable" style={{ backgroundColor: "white", width: "600px", fontSize: "9px", lineHeight: "1.5", color: "#222"}}>
                            <tbody>
                            <tr>
                                <td className="PeerColumnHeading PeerTabledataCenterMobile" style={{ textAlign:"center" }}>History</td>
                                <td className="PeerColumnHeading PeerTabledataCenterMobile" style={{ textAlign: "center" }}>Company Name</td>
                                <td className="PeerColumnHeading PeerTabledataCenterMobile" style={{ textAlign: "center" }}>Symbol</td>
                                <td className="PeerColumnHeading PeerTabledataCenterMobile" style={{ textAlign: "center" }}>% Change</td>
                                </tr>
                            </tbody>
                            <tbody>
                            {pageData.activities?.map(dataKey => (
                                <>
                                    <tr>
                                        <td className="PeerTabledataLeft SubHeader activitColumn" colspan="4" style={{textAlign:"left", paddingLeft:"50px", fontSize:"9px !important", fontWeight: "500"}}>{dataKey.quarter}</td>
                                    </tr>
                                    {dataKey.activity.map((dataItem, index) => (
                                        <tr>
                                            <td className={index % 2 === 0 ? "PeerTabledataCenterMobile SubHeader OddDiv" : "PeerTabledataCenterMobile SubHeader"}>&nbsp;</td>
                                            <td className={index % 2 === 0 ? "PeerTabledataCenterMobile SubHeader OddDiv" : "PeerTabledataCenterMobile SubHeader"}>{dataItem.company_name }</td>
                                            <td className={index % 2 === 0 ? "PeerTabledataCenterMobile SubHeader OddDiv" : "PeerTabledataCenterMobile SubHeader"}><a href={getUrl(dataItem.stock_symbol)} target="_blank" style={{ textDecoration: "None" }}>{dataItem.stock_symbol}</a></td>
                                            <td className={getClassName(index, dataItem.pct_change)}>{dataItem.change_desc} </td>
                                        </tr>
                                        ))
}
                                    
                                </>
                            ))}
                            {(pageData.dataNotFound === true || pageData.activities?.length === 0 || pageData.activities === undefined) &&
                                <tr>
                                    <td colspan={pageData.columns.length + 2}>Data not found</td>
                                </tr>
                            }
                            </tbody>
                        </table>
                    </div>
                </>
            }
            {Object.keys(pageData).length === 0 &&
                <Loading />
            }
        </div>
    );
}

export default InvestmentActivityMobile;